import React from "react";
import {Link} from "react-router-dom";
import fondo from "../assets/fondo1.webp"
import  "./LandingPage.css"

export default function LandingPage(){
    return (
        <div className="stylesContainer">
            <div className="containerLanding">
                <Link className="title" to="/home">
                <h1 className="Ingresar">Bienvenidos</h1>
                </Link>
            </div>
            <img className="background" src={fondo} alt="not found" />
        </div>
    )
}